import React from "react";
import "./pdf.css";
import merinasoft from "../image/manaviea_attire_black_and_white_logo.png";
import { convertNumberToWords } from "./ConvertNumberToWord";

export const ComponentToPrint = React.forwardRef((props, ref) => {
  const {
    supplier,
    address,
    mobile,
    employee_name,
    date,
    total,
    due,
    paid,
    invoice,
    rows,
    vat,
  } = props;
  const words = convertNumberToWords(total);
  console.log("PRINT DATA:", rows);
  return (
    <div 
    ref={ref}

    >
      <div>
        {/* Header Section */}
        <div className="headers">
          <img src={merinasoft} alt="Company Logo" className="logo" />
          <div className="company-info">
            <div className="company-name">Manaviea Attire</div>

          </div>
        </div>

      </div>
    </div>
  );
});
